export default {"src":"/_next/static/media/coinbase.8e7b47cd.svg","height":49,"width":136,"blurWidth":0,"blurHeight":0};